import * as R from 'ramda'
import { Just, Nothing } from 'sanctuary'
import { isEmptyOrNil } from './empty'

/** a -> Maybe a */
export const nullableToMaybe = (value) =>
  R.isNil(value) ? Nothing : Just(value)

export const mapRight = (fn) =>
  R.ifElse(R.complement(isEmptyOrNil), fn, R.always(undefined))
